import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-taux-chomage',
    templateUrl: './taux-chomage.component.html',
    styleUrls: ['./taux-chomage.component.scss']
})
export class TauxChomageComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }
}
